var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0138 9.16988L23.0388 13.2163C23.2125 13.5191 23.4463 13.7823 23.7256 13.9895C24.0049 14.1967 24.3236 14.3432 24.6617 14.4201L28.3239 15.0437C30.6649 15.4353 31.1963 17.1467 29.5303 18.8436L26.6579 21.7442C26.4094 22.0244 26.2272 22.3581 26.1252 22.7199C26.0231 23.0817 26.004 23.4623 26.0691 23.8327L26.8877 27.4005C27.5197 30.2142 26.0404 31.3164 23.5702 29.8515L20.1377 27.7921C19.7877 27.6066 19.3984 27.5097 19.0031 27.5097C18.6079 27.5097 18.2185 27.6066 17.8685 27.7921L14.4361 29.8515C11.9659 31.3018 10.4866 30.2142 11.1185 27.4005L11.9371 23.8327C12.0023 23.4623 11.9831 23.0817 11.8811 22.7199C11.7791 22.3581 11.5969 22.0244 11.3483 21.7442L8.47594 18.8436C6.79561 17.1467 7.34136 15.4353 9.68233 15.0437L13.3446 14.4201C13.6878 14.3469 14.0121 14.202 14.2965 13.9947C14.581 13.7874 14.8193 13.5222 14.9962 13.2163L17.0212 9.12632C18.1271 6.95083 19.9079 6.95087 21.0138 9.16988Z",
    fill: "#F8BC54",
    stroke: "#F8BC54",
    strokeWidth: 1.56817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01587 12.1471C4.86924 12.0136 4.81145 11.6647 5.00928 11.361C5.08568 11.2437 5.25114 11.2844 5.30439 11.4139L5.46988 11.8162C5.69687 11.8162 6.06016 11.8493 5.87857 11.9816C5.65158 12.1471 5.15774 12.2763 5.01587 12.1471Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellow);
export default __webpack_public_path__ + "static/media/star_yellow.7645cf00df4306bdfe0d96f3364b45b7.svg";
export { ForwardRef as ReactComponent };